import { AccountBalanceOutlined } from '@mui/icons-material'
import BusinessIcon from '@mui/icons-material/Business'
import CommuteIcon from '@mui/icons-material/Commute'
import IntegrationIcon from '@mui/icons-material/IntegrationInstructions'
import MapIcon from '@mui/icons-material/Map'
import PeopleIcon from '@mui/icons-material/People'
import SettingsApplicationsIcon from '@mui/icons-material/SettingsApplications'
import ViewCompact from '@mui/icons-material/ViewCompact'
import { Box, Tab, Tabs } from '@mui/material'
import IntegrationPanel from 'components/Supplier/Manage/Integration/IntegrationPanel'
import { Fragment, useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Supplier } from '../../../api/supplier/suppliers.types'
import { suppliersAPI } from '../../../api/supplier/suppliersAPI'
import Users from '../../../components/Clients/ClientManagement/Users/Users'
import Billing from '../../../components/Supplier/Manage/Billing/Billing'
import Overrides from '../../../components/Supplier/Manage/ChargeOverride/Overrides'
import Company from '../../../components/Supplier/Manage/Company/Company'
import FixedRoutesComponent from '../../../components/Supplier/Manage/FixedRoutes/FixedRoutesComponent'
import Operations from '../../../components/Supplier/Manage/Operations/Operations'
import Taxis from '../../../components/Supplier/Manage/Vehicles/Taxis'
import { BaseLayout } from '../../../layouts/Base/BaseLayout'
import { setSupplier } from '../../../reducers/suppliersReducer'
import { SupplierProvider } from '../SupplierContext'
import styles from './SupplierManagementPageStyle'

const a11yProps = (index: number) => {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  }
}

const SupplierPage = () => {
  const { id } = useParams<{ id: string }>()
  const [progress, setProgress] = useState(0)
  const dispatch = useDispatch()
  const supplier: Supplier = useSelector(
    (state: any) => state.suppliers.supplier,
  )

  const {
    isLoading,
    error,
    data: supplierData,
    refetch,
  } = useQuery({
    queryKey: [`fetchSupplierById_${id}`],
    queryFn: async () =>
      suppliersAPI
        .getSupplierById(id)
        .then((response) => dispatch(setSupplier(response.data))),
    refetchOnWindowFocus: false,
  })
  if (isLoading) {
    return <div>Fetching Suppliers</div>
  }

  if (error) {
    return <div>{JSON.stringify(error)}</div>
  }

  const handleChange = (event: any, index: number) => {
    setProgress(index)
    refetch()
  }

  return (
    supplier && (
      <Fragment>
        <BaseLayout
          pageTitle={`Supplier: ${
            supplier.alias
              ? `${supplier.alias} (${supplier.companyName})`
              : supplier.companyName
          }`}
        />

        <Box component={'div'} sx={styles.root}>
          <Tabs
            value={progress}
            onChange={(event, index) => handleChange(event, index)}
            variant="scrollable"
            scrollButtons
            indicatorColor="primary"
            textColor="primary"
            aria-label="scrollable force tabs example"
            orientation="vertical"
            sx={styles.componentPanel}
            allowScrollButtonsMobile
          >
            <Tab label="Company" icon={<BusinessIcon />} {...a11yProps(0)} />
            <Tab
              label="Billing"
              icon={<AccountBalanceOutlined />}
              {...a11yProps(1)}
            />
            <Tab label="Users" icon={<PeopleIcon />} {...a11yProps(2)} />
            <Tab
              label="Overrides"
              icon={<SettingsApplicationsIcon />}
              {...a11yProps(3)}
            />
            <Tab label="Operations" icon={<ViewCompact />} {...a11yProps(4)} />
            <Tab label="Vehicles" icon={<CommuteIcon />} {...a11yProps(5)} />
            <Tab label="Fixed routes" icon={<MapIcon />} {...a11yProps(6)} />
            <Tab
              label="Integration"
              icon={<IntegrationIcon />}
              {...a11yProps(7)}
            />
          </Tabs>
          {progress === 0 && <Company />}

          {progress === 1 && supplierData && (
            <Billing supplierData={supplierData} />
          )}
          {progress === 2 && <Users client={supplierData?.payload} />}
          {progress === 3 && <Overrides />}
          {progress === 4 && <Operations />}
          {progress === 5 && <Taxis />}
          {progress === 6 && <FixedRoutesComponent />}
          {progress === 7 && <IntegrationPanel />}
        </Box>
      </Fragment>
    )
  )
}

const SupplierManagementPage = () => {
  return (
    <SupplierProvider>
      <SupplierPage />
    </SupplierProvider>
  )
}

export default SupplierManagementPage
